import { Css } from "~generated/css";
import { useTestIds } from "~utils";

type SwitchProps = {
  value: boolean;
  onClick: () => void;
};

export const Switch = (props: SwitchProps) => {
  const { value = false, onClick } = props;
  const tid = useTestIds(props, "switch");

  return (
    <div
      onClick={onClick}
      css={{
        ...Css.cursorPointer.df.relative
          .wPx(32)
          .hPx(16)
          .pPx(2)
          .br12.bgLightGray.add("transition", "background-color 0.2s ease-in-out").$,
        ...Css.if(value).bgOrange300.$,
      }}
      {...tid}
    >
      <div
        css={{
          ...Css.relative
            .wPx(12)
            .hPx(12)
            .bgGray.leftPx(value ? 16 : 0)
            .br12.add("transition", "left 0.2s ease-in-out").bshButton.$,
          ...Css.if(value).bgWhite.$,
        }}
      />
    </div>
  );
};
